import { useQuery } from "react-query";
import { getHierarchyOrgChart } from "actions/CarrierAgreementMgmt/Hierarchy";

export const useGetHierarchyOrgChart = () => {
  return useQuery("GetHierarchyOrgChart", getHierarchyOrgChart, {
    refetchOnWindowFocus: false,
  });
};
